import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { parseOAuthResponseFromUrl } from '../oidc/parseFromUrl.js';
import { AuthStateManager } from './AuthStateManager.js';
import { ServiceManager } from './ServiceManager/browser.js';
import AuthSdkError from '../errors/AuthSdkError.js';
import '../errors/WWWAuthError.js';
function mixinCore(Base) {
  return /*#__PURE__*/function (_Base) {
    function OktaAuthCore() {
      var _this;
      _classCallCheck(this, OktaAuthCore);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, OktaAuthCore, [].concat(args));
      _this.authStateManager = new AuthStateManager(_this);
      _this.serviceManager = new ServiceManager(_this, _this.options.services);
      return _this;
    }
    _inherits(OktaAuthCore, _Base);
    return _createClass(OktaAuthCore, [{
      key: "start",
      value: function () {
        var _start = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.serviceManager.start();
              case 2:
                this.tokenManager.start();
                if (this.token.isLoginRedirect()) {
                  _context.next = 6;
                  break;
                }
                _context.next = 6;
                return this.authStateManager.updateAuthState();
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function start() {
          return _start.apply(this, arguments);
        }
        return start;
      }()
    }, {
      key: "stop",
      value: function () {
        var _stop = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                this.tokenManager.stop();
                _context2.next = 3;
                return this.serviceManager.stop();
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function stop() {
          return _stop.apply(this, arguments);
        }
        return stop;
      }()
    }, {
      key: "handleRedirect",
      value: function () {
        var _handleRedirect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(originalUri) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.handleLoginRedirect(undefined, originalUri);
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function handleRedirect(_x) {
          return _handleRedirect.apply(this, arguments);
        }
        return handleRedirect;
      }()
    }, {
      key: "handleLoginRedirect",
      value: function () {
        var _handleLoginRedirect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(tokens, originalUri) {
          var state, oAuthResponse, restoreOriginalUri;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                state = this.options.state;
                if (!tokens) {
                  _context4.next = 6;
                  break;
                }
                this.tokenManager.setTokens(tokens);
                originalUri = originalUri || this.getOriginalUri(this.options.state);
                _context4.next = 25;
                break;
              case 6:
                if (!this.isLoginRedirect()) {
                  _context4.next = 24;
                  break;
                }
                _context4.prev = 7;
                _context4.next = 10;
                return parseOAuthResponseFromUrl(this, {});
              case 10:
                oAuthResponse = _context4.sent;
                state = oAuthResponse.state;
                originalUri = originalUri || this.getOriginalUri(state);
                _context4.next = 15;
                return this.storeTokensFromRedirect();
              case 15:
                _context4.next = 22;
                break;
              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](7);
                _context4.next = 21;
                return this.authStateManager.updateAuthState();
              case 21:
                throw _context4.t0;
              case 22:
                _context4.next = 25;
                break;
              case 24:
                return _context4.abrupt("return");
              case 25:
                _context4.next = 27;
                return this.authStateManager.updateAuthState();
              case 27:
                this.removeOriginalUri(state);
                restoreOriginalUri = this.options.restoreOriginalUri;
                if (!restoreOriginalUri) {
                  _context4.next = 34;
                  break;
                }
                _context4.next = 32;
                return restoreOriginalUri(this, originalUri);
              case 32:
                _context4.next = 35;
                break;
              case 34:
                if (originalUri) {
                  window.location.replace(originalUri);
                }
              case 35:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this, [[7, 17]]);
        }));
        function handleLoginRedirect(_x2, _x3) {
          return _handleLoginRedirect.apply(this, arguments);
        }
        return handleLoginRedirect;
      }()
    }, {
      key: "handleIDPPopupRedirect",
      value: function handleIDPPopupRedirect() {
        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
        var res = parseOAuthResponseFromUrl(this, {
          responseMode: 'query',
          url: url
        });
        if (res.state) {
          var channel = new BroadcastChannel("popup-callback:".concat(res.state));
          channel.postMessage(res);
          channel.close();
        } else {
          throw new AuthSdkError('Unable to parse auth code params');
        }
      }
    }]);
  }(Base);
}
export { mixinCore };